import {request} from '@/sealFilter/request'

// 连接内网ip

// 创建直播
export function creatlive (data) {
  return request({
    url: '/live/action/create',
    method: 'GET',
    params: data
  })
}
// 创建录播
export function createRecord (data) {
  return request({
    url: '/live/action/createRecord',
    method: 'GET',
    params: data
  })
}
// 获取直播url
export function startlive (data) {
  return request({
    url: '/live/action/start',
    method: 'GET',
    params: data
  })
}
// 直播列表 - 分页
export function netmettinglist (data) {
  return request({
    url: '/live/action/list',
    method: 'GET',
    params: data
  })
}
// 直播列表 -所有
export function netmettinglistAll (data) {
  return request({
    url: '/live/action/listAll',
    method: 'GET',
    params: data
  })
}
// 获取直播信息
export function netmettingfetch (data) {
  return request({
    url: '/live/action/fetch',
    method: 'GET',
    params: data
  })
}
// 修改直播
export function netmettingupdate (data) {
  return request({
    url: '/live/action/update',
    method: 'GET',
    params: data
  })
}
// 删除录播
export function deleteRecord (data) {
  return request({
    url: '/live/action/deleteRecord',
    method: 'GET',
    params: data
  })
}
// 删除直播
export function deleteRecordLubo (data) {
  return request({
    url: '/live/action/delete',
    method: 'GET',
    params: data
  })
}
// 创建活动
export function createActivity (data) {
  return request({
    url: '/activity/action/create',
    method: 'GET',
    params: data
  })
}
// 修改活动
export function updateActivity (data) {
  return request({
    url: '/activity/action/update',
    method: 'GET',
    params: data
  })
}
// 活动排程
export function activitylistOneDay (data) {
  return request({
    url: '/activity/action/listOneDay',
    method: 'GET',
    params: data
  })
}
// 直播首页获取五天的
export function activitylistSomeDay (data) {
  return request({
    url: '/activity/action/listSomeDay',
    method: 'GET',
    params: data
  })
}
// 删除活动排程
export function actiondelete (data) {
  return request({
    url: '/activity/action/delete',
    method: 'GET',
    params: data
  })
}
// 修改录播
export function updateRecord (data) {
  return request({
    url: '/live/action/updateRecord',
    method: 'GET',
    params: data
  })
}

export function endLive (webinarId) {
    return request({
        url: '/live/action/stop',
        method: 'GET',
        params: {
            webinarId
        }
    })
}

export function queryLiveStatus (webinarId) {
    return request({
        url: '/live/action/state',
        method: 'GET',
        params: {
            webinarId
        }
    })
}

// 将直播设置为预告状态
export function setLiveToPreState (webinarId) {
    return request({
        url: '/live/action/state',
        method: 'GET',
        params: {
            webinarId
        }
    })
}

// 获取主持人口令
export function getHostToken (webinarId) {
    return request({
        url: '/live/action/queryHostPassword',
        method: 'GET',
        params: {
            webinarId
        }
    })
}



// WEBPACK FOOTER //
// ./src/api/VhallLive.js